import React, { type FunctionComponent } from 'react';

import PageTree from '../page-tree';
import { TranslationsProvider, DEFAULT_LOCALE } from '../translations-provider';
import { type ConfluencePageTreeProps } from './types';
export type { ConfluencePageTreeProps } from './types';

export const ConfluencePageTree: FunctionComponent<ConfluencePageTreeProps> = ({
	locale = DEFAULT_LOCALE,
	...props
}) => {
	return (
		<TranslationsProvider locale={locale}>
			<PageTree {...props} />
		</TranslationsProvider>
	);
};
